module.exports = __webpack_public_path__ + "img/avatar1.5a9ed517.png";